import React, { useState, useEffect, useCallback } from "react";
import "../carousel.css";

const Carousel = ({ slides, autoPlayInterval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = useCallback(() => {
    const isFirstSlide = currentIndex === 0;
    const newIndex = isFirstSlide ? slides.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  const goToNext = useCallback(() => {
    const isLastSlide = currentIndex === slides.length - 1;
    const newIndex = isLastSlide ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  }, [currentIndex, slides.length]);

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  useEffect(() => {
    if (autoPlayInterval) {
      const timer = setInterval(() => {
        goToNext();
      }, autoPlayInterval);

      // Clear the interval when the component unmounts or currentIndex changes
      return () => clearInterval(timer);
    }
  }, [currentIndex, autoPlayInterval, goToNext]);

  // Handle case where slides array is empty
  if (!slides || slides.length === 0) {
    return <div>No slides to display.</div>;
  }

  return (
    <div className="carousel-container" aria-roledescription="carousel">
      <button
        onClick={goToPrevious}
        className="arrow left-arrow prev-btn"
        aria-label="Previous Slide"
      >
        &#10094;
      </button>
      <button
        onClick={goToNext}
        className="arrow right-arrow next-btn"
        aria-label="Next Slide"
      >
        &#10095;
      </button>

      <div className="slide-container">
        <div
          className="slide-wrapper"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {slides.map((slide) => (
            <div className="slide" key={slide.id}>
              <img
                src={slide.imageUrl}
                alt={slide.caption}
                className="slide-image"
              />
              <div className="slide-caption">{slide.caption}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="dots-container">
        {slides.map((slide, slideIndex) => (
          <button
            key={slide.id}
            className={`dot ${currentIndex === slideIndex ? "active" : ""}`}
            onClick={() => goToSlide(slideIndex)}
            aria-label={`Go to slide ${slideIndex + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
